import { render, staticRenderFns } from "./Ralan.vue?vue&type=template&id=26ed10a0&"
import script from "./Ralan.vue?vue&type=script&lang=js&"
export * from "./Ralan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports